<template>
  <div class="main_tasklist">
    <div class="cont_tit">
      <div class="cont_tit_txt">업무 현황 리스트</div>
      <div class="cont_tit_select">
        <img src="../../../assets/img/admin/etners-web/place_check.png">사업부 선택
        <div class="kendo_ui">

          <kendo-dropdownlist
            ref="divisionNameRef"
            id="divisionName"
            :data-source="this.$store.state.gewCodeStore.search.combobox.division.data"
            :data-text-field="'cdNm'"
            :data-value-field="'cdNameSpace'"
            :option-label="labelText"
            v-bind:style="'width: 100%;height: 100%;'"
            @select="onSelectDivisionCd"
          >
          </kendo-dropdownlist>
        </div>
      </div>
    </div>
    <div class="main_tasklist_cont">

      <ul>
        <li v-for="(inout,key) in mainInOutStatusArray" @click="onClickStatus(key)" style="cursor: pointer;">
          <div class="process_tit">{{inout.statusName}}</div>
          <div class="process_num" :id="key" name="process_num_cnt"><a>{{inout.statusCnt}}</a></div>
        </li>

      </ul>


      <kendo-grid ref="mainInOutListGridRef"
                  :data-source="computedMainInOutListGridRows"
                  :height="634"
                  :sortable="true"
                  :scrollable-virtual="true"
                  :pageable-numeric="false"
                  :pageable-previous-next="false"
                  :pageable-always-visible="false"
                  :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
                  :columns="mainInOutListColumns"
                  class="tasklist_table"
      >
      </kendo-grid>
      <div style="float:right;padding-top:8px; color:#fe5f40;font-size:13px;">※ 작업요청일시 기준 최근 30일 동안의 업무 조회만 가능합니다.</div>

    </div>
  </div>


</template>

<script>

  import ApiConfig from '@/api/api.config'
  import EtnersKendoGridUtil from "../../../common/kendo.grid.util";
  import EtnersParseUtil from "../../../common/etners.parse.util";
  import EtnersCommonUtil from "../../../common/etners.common.util";
  import EtnersChartCommonUtil from '../../../common/admin/chart/etners.admin.chart.util'
  const gewApiDomain = 'https://dsoffice-api.etnersplatform.com/'
  export default {
    name: 'MainTaskView',
    created(){
      setTimeout(() => {
        const dataSource = this.$store.state.gewCodeStore.search.combobox.division.data
        dataSource.forEach((division) => {
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: 'ALL'})
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: '01'})
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: '02'})
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: '03'})
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: '04'})
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: '05'})
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: '06'})
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: '07'})
          this.autoClickArr.push({divisionCd: division.cdNameSpace, statusCdId: '099'})
        })
      }, 2000)
    },
    mounted: function () {
      const refs = this.$refs
      const vue = this
      const autoClickArr = vue.autoClickArr


        vue.onSelectDivisionParamStatus('ALL')
        let intervalCnt = 0

        setInterval(function () {
          if (refs.divisionNameRef !== undefined) {
            refs.divisionNameRef.kendoWidget().value(autoClickArr[intervalCnt].divisionCd)
          }

            vue.onClickStatus(autoClickArr[intervalCnt].statusCdId)

            if (intervalCnt !== autoClickArr.length - 1) {

              intervalCnt++
            } else {
              intervalCnt = 0
            }

        }, 10000)

    },
    data: function () {

      const autoClickArr = []
      autoClickArr.push({divisionCd: '', statusCdId: 'ALL'})
      autoClickArr.push({divisionCd: '', statusCdId: '01'})
      autoClickArr.push({divisionCd: '', statusCdId: '02'})
      autoClickArr.push({divisionCd: '', statusCdId: '03'})
      autoClickArr.push({divisionCd: '', statusCdId: '04'})
      autoClickArr.push({divisionCd: '', statusCdId: '05'})
      autoClickArr.push({divisionCd: '', statusCdId: '06'})
      autoClickArr.push({divisionCd: '', statusCdId: '07'})
      autoClickArr.push({divisionCd: '', statusCdId: '099'})

      return {
        labelText: '전체',
        platformDomain: ApiConfig.platformDomain,
        clickStatus: '',
        mainInOutStatusArray: {
          'ALL': {statusCdId: 'ALL', statusName: '전체', statusCnt: 0},
          '01': {statusCdId: '01', statusName: '접수요청', statusCnt: 0},
          '02': {statusCdId: '02', statusName: '협의수정', statusCnt: 0},
          '03': {statusCdId: '03', statusName: '협의완료', statusCnt: 0},
          '04': {statusCdId: '04', statusName: '진행중', statusCnt: 0},
          '05': {statusCdId: '05', statusName: '작업완료', statusCnt: 0},
          '06': {statusCdId: '06', statusName: '완료수정 ', statusCnt: 0},
          '07': {statusCdId: '07', statusName: '완료승인', statusCnt: 0},
          '099': {statusCdId: '99', statusName: '취소', statusCnt: 0}
        },
        mainInOutListColumns: [
          {
            title: '진행현황', width: '70px', template: function (dataItem) {
              let processCssName = 'process01'
              switch (dataItem.status) {
                case '003_01':
                case '015_01':
                  processCssName = 'process01'
                  break;
                case '003_02':
                case '015_02':
                  processCssName = 'process02'
                  break;
                case '003_03':
                case '015_03':
                  processCssName = 'process03'
                  break;
                case '003_04':
                case '015_04':
                  processCssName = 'process04'
                  break;
                case '003_05':
                case '015_05':
                  processCssName = 'process05'
                  break;
                case '003_06':
                case '015_06':
                  processCssName = 'process06'
                  break;
                case '003_07':
                case '015_07':
                  processCssName = 'process07'
                  break;
                case '003_99':
                case '015_99':
                  processCssName = 'process08'
                  break;
                default:
                  processCssName = 'process08'
                  break;
              }
              return `<div class='process_icon ${processCssName}' style='text-align: center!important;'>${dataItem.cvtStatus}</div>`
            }
          },
          {
            title: '구분', width: '40px'
            , template: function (dataItem) {
              let processCssName = 'process_sort01'
              switch (dataItem.status) {
                case '003_01':
                case '015_01':
                  processCssName = 'process_sort01'
                  break;
                case '003_02':
                case '015_02':
                  processCssName = 'process_sort02'
                  break;
                case '003_03':
                case '015_03':
                  processCssName = 'process_sort03'
                  break;
                case '003_04':
                case '015_04':
                  processCssName = 'process_sort04'
                  break;
                case '003_05':
                case '015_05':
                  processCssName = 'process_sort05'
                  break;
                case '003_06':
                case '015_06':
                  processCssName = 'process_sort06'
                  break;
                case '003_07':
                case '015_07':
                  processCssName = 'process_sort07'
                  break;
                case '003_99':
                case '015_99':
                  processCssName = 'process_sort08'
                  break;
                default:
                  processCssName = 'process_sort08'
                  break;
              }
              return `<div class='${processCssName}'>${dataItem.inOutType}</div>`
            }
          },
          {
            title: '세부내용', width: '200px'
            , template: function (dataItem) {
              let url = ''
              if (dataItem.inOutType === '입고') {
                url = 'incoming'
              } else {
                url = 'outgoing'
              }
              return `<a href='/business/${url}/detail/${dataItem.cmpyCd}/${dataItem.reqNo}' style="height: 59px!important;">${dataItem.title}</a>`
            }
          },
          {field: 'fmtFrstRgstDt', title: '접수일시', width: '110px'},
          {field: 'fmtWorkRequestDt', title: '작업요청일시', width: '110px'}
        ],
        autoClickArr: autoClickArr
      }
    },
    methods: {
      /*onSelectBusinessPlaceCd: function() {
        this.initAggregationByStatus() //상태 통계 초기화
        this.onClickStatus('ALL') //상태 검색 초기화
        this.commonOnChangeEvent()
      },*/
      onSelectDivisionCd: function () {

        this.initAggregationByStatus() //상태 통계 초기화
        this.onClickStatus('ALL') //상태 검색 초기화
        this.commonOnChangeEvent()
      },
      onSelectDivisionParamStatus: function (status) {

        this.initAggregationByStatus() //상태 통계 초기화
        this.onClickStatus(status) //상태 검색 초기화
        this.commonOnChangeEvent()
      },
      initAggregationByStatus: function () {
        this.mainInOutStatusArray['ALL'].statusCnt = 0
        this.mainInOutStatusArray['01'].statusCnt = 0
        this.mainInOutStatusArray['02'].statusCnt = 0
        this.mainInOutStatusArray['03'].statusCnt = 0
        this.mainInOutStatusArray['04'].statusCnt = 0
        this.mainInOutStatusArray['05'].statusCnt = 0
        this.mainInOutStatusArray['06'].statusCnt = 0
        this.mainInOutStatusArray['07'].statusCnt = 0
        this.mainInOutStatusArray['099'].statusCnt = 0

      },
      aggregationByStatus: function (status) {
        this.mainInOutStatusArray['ALL'].statusCnt = this.mainInOutStatusArray['ALL'].statusCnt + 1
        switch (status) {
          case '003_01':
          case '015_01'://접수요청
            this.mainInOutStatusArray['01'].statusCnt = this.mainInOutStatusArray['01'].statusCnt + 1
            break;
          case '003_02':
          case '015_02': //협의수정
            this.mainInOutStatusArray['02'].statusCnt = this.mainInOutStatusArray['02'].statusCnt + 1
            break;
          case '003_03':
          case '015_03'://협의완료
            this.mainInOutStatusArray['03'].statusCnt = this.mainInOutStatusArray['03'].statusCnt + 1
            break;
          case '003_04':
          case '015_04'://진행중
            this.mainInOutStatusArray['04'].statusCnt = this.mainInOutStatusArray['04'].statusCnt + 1
            break;
          case '003_05':
          case '015_05'://작업완료
            this.mainInOutStatusArray['05'].statusCnt = this.mainInOutStatusArray['05'].statusCnt + 1
            break;
          case '003_06':
          case '015_06'://완료수정
            this.mainInOutStatusArray['06'].statusCnt = this.mainInOutStatusArray['06'].statusCnt + 1
            break;
          case '003_07':
          case '015_07'://완료승인
            this.mainInOutStatusArray['07'].statusCnt = this.mainInOutStatusArray['07'].statusCnt + 1
            break;
          case '003_99':
          case '015_99'://취소
            this.mainInOutStatusArray['099'].statusCnt = this.mainInOutStatusArray['099'].statusCnt + 1
            break;
        }


      },
      onClickStatus(status) {

        const statusCnt = document.getElementsByName('process_num_cnt')

        if (status !== undefined && status !== '') {
          this.clickStatus = status
          for (let i = 0; i < statusCnt.length; i++) {
            statusCnt[i].classList.remove('on')
          }
          document.getElementById(status).classList.add('on')
        } else {
          this.clickStatus = 'ALL'

        }

        this.commonOnChangeEvent()
      },
      commonOnChangeEvent() {

        if (this.$refs.mainInOutListGridRef !== undefined) {
          let mainInOutListGridRef = this.$refs.mainInOutListGridRef.kendoWidget()

          if (mainInOutListGridRef !== undefined) {
            const dataSource = this.$refs.mainInOutListGridRef.kendoWidget().dataSource

            if (dataSource !== undefined) {
              dataSource.page(1)
              dataSource.read()
            }
          }
        }
      },
      // 검색조건 생성
      currentPageFilterOption: function () {
        let searchFilterOptions = []

        const refs = this.$refs

        // 사업부 검색
        if (refs.divisionNameRef !== undefined) {
          const divisionName = refs.divisionNameRef.kendoWidget().value()

          if (divisionName !== undefined && divisionName !== '') {
            searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({
              operator: 'contains',
              columnName: 'requestDivisionCd',
              value: divisionName
            }))
          }
        }


        if (this.clickStatus !== undefined && this.clickStatus !== 'ALL' && this.clickStatus !== null) {
          if (this.clickStatus === '099') {
            this.clickStatus = '99'
          }
          const incomingStatus = `003_${this.clickStatus}`
          const outgoingStatus = `015_${this.clickStatus}`
          searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({
            operator: 'contains',
            columnName: 'inStatus',
            value: incomingStatus
          }))

          searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({
            operator: 'contains',
            columnName: 'outStatus',
            value: outgoingStatus
          }))

        }

        const startDate = new Date()
        let monthOfYear = startDate.getMonth()
        startDate.setMonth(monthOfYear - 1)

        searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({
          operator: "goe",
          columnName: "workRequestDt",
          value: EtnersParseUtil.convertDateToStringYYYYMMDDFormat(startDate)
        }))


        return searchFilterOptions.length === 0 ? undefined : searchFilterOptions
      },
      getGewSCodeMap: function () {
        let VUEX_ALL_SOL_CODE_MAP = {}
//
        if (sessionStorage.getItem('__VUEX_ALL_SOL_CODE_MAP__') != null) {
          VUEX_ALL_SOL_CODE_MAP = JSON.parse(sessionStorage.getItem('__VUEX_ALL_SOL_CODE_MAP__'))
          //
        } else {
          let allSolCodeUrl = `${ApiConfig.singleDomain}/v1/ebmp/code/allSolutionCodesBySolCd.json`
          let allSolCodeParam = {
            'solCd': ['1007'],
          }
          //
          ApiUtil.post(allSolCodeUrl, allSolCodeParam).then(response => {
            VUEX_ALL_SOL_CODE_MAP = response.data.allSolutionCodeMap
            sessionStorage.setItem('__VUEX_ALL_SOL_CODE_MAP__', JSON.stringify(VUEX_ALL_SOL_CODE_MAP))
          })
        }
      }
    },
    computed: {
      computedMainInOutListGridRows: function () {
        // parameterMap 안에서의 this는 Vue가 아니므로 미리 vm 변수로 바인딩.
        const vm = this
        const store = this.$store

        const mainInOutListDataSource = new kendo.data.DataSource({
          name: 'mainInOutListDataSource',
          page: 1,
          pageSize: 10000,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: false,
          transport: {
            read: {
              url: `${gewApiDomain}/v1/ebmp/gew/inout/mainInOutList.json`,
              type: 'POST',
              dataType: 'json',
              contentType: 'application/json',
              cache: false,
            },
            parameterMap: function (options, operation) {

              if (operation === 'read') {
                const activeKendoGridFilterOption = true
                let loginUserToken = sessionStorage.lutk
                const customEtnersFilters = EtnersKendoGridUtil.convertKendoFilterToEtnersFilterOption(options, operation)

                let paramToKendoFilters = vm.currentPageFilterOption()

                let integrationCustomFilters = paramToKendoFilters

                let params = {
                  loginUserToken: loginUserToken,
                  skip: options.skip,
                  take: options.take,
                  page: options.page,
                  pageSize: options.pageSize,
                  filter: integrationCustomFilters !== undefined ? integrationCustomFilters : undefined,
                  sort: options.sort,
                  requestType: 'PAGING', // PAGING or EXPORT
                }


                return kendo.stringify(params)
              }

              if (operation !== 'read' && options.models) {
                return {models: kendo.stringify(options.models)}
              }
            },
          },
          schema: {
            type: 'json',
            parse: function (response) {
              let solutionCodeMap = EtnersChartCommonUtil.getGewSCodeMapUsingVuex()

              // 맵이 초기화되었는지 여부 확인
              const initSolutionCodeMapFl = solutionCodeMap !== undefined


              //통계 초기화 , 진행상태를 클릭했을때는 초기화하지 않는다.
              if (vm.clickStatus === 'ALL') {
                vm.initAggregationByStatus()
              }
              if (initSolutionCodeMapFl) {
                let changeResultData = response.resultData
                for (let i = 0; i < changeResultData.length; i++) {
                  let row = changeResultData[i]

                  //진행상태를 클릭했을때는 집계하지 않는다.
                  if (vm.clickStatus === 'ALL') {
                    vm.aggregationByStatus(row.status)
                  }
                  row.cvtStatus = EtnersParseUtil.codeToText(solutionCodeMap, row.status)
                  row.fmtWorkRequestDt = EtnersParseUtil.convertYYYYMMDDHHFormat(row.workRequestDt) + "시"
                  row.fmtFrstRgstDt = EtnersParseUtil.convertYYYYMMDDHHMISSFormat(row.frstRgstDt)
                }

                response.resultData = changeResultData
              } else {
                // 만약 코드-텍스트 변환을 위한 맵이 초기화되지 않았다면, 다시 한 번 그리드를 읽어들이도록 처리
                setTimeout(function () {
                  vm.$refs.mainInOutListGridRef.kendoWidget().dataSource.read()
                }, 300)
              }

              return response
            },
            total: function (response) {
              // console.log("response.total : " + response.total)
              return response.total
            },
            data: function (response) {
              if (response.resultStatus.messageCode === '2000') {
                return response.resultData
              } else {
                kendo.alert('message: ' + response.resultStatus.messageText)

                return ''
              }
            },
          },

          error: function (e) {
            console.log('error event handler', e)
          },
        })

        if (mainInOutListDataSource.total === 0) {
          if (document.getElementsByClassName('tasklist_table')[0].childElementCount !== 0) {
            document.getElementsByClassName('tasklist_table')[0].children[1].innerHTML = '<table><tbody><td colspan=\'7\' style=\'text-align:center\'>데이터가 없습니다.</td></tbody></table>'
          }
        }

        return mainInOutListDataSource
      },
    }
  }
</script>
<style>
  div.tasklist_table table th {
    background-color: #f2f7ff;
    border-bottom: 1px solid #ebebeb;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -1px;
    text-align: center !important;
  }

</style>
